import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import ImageList from "@material-ui/core/ImageList";
import ImageListItem from "@material-ui/core/ImageListItem";
// import ImageListItemBar from "@material-ui/core/ImageListItemBar";
import ListSubheader from "@material-ui/core/ListSubheader";
import LinearProgress from "@material-ui/core/LinearProgress";
import { Box, Grid, TextField, Button, Typography } from "@material-ui/core";
import api from "../../../axios";
import Api from "../../../Api";
import { useAlert } from "react-alert";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "space-around",
    overflow: "hidden",
    backgroundColor: theme.palette.background.paper,
  },
  imageList: {
    // width: 800,
    height: 601,
  },
  icon: {
    color: "rgba(255, 255, 255, 0.54)",
  },
}));

function LinearProgressWithLabel(props) {
  return (
    <Box display="flex" alignItems="center">
      <Box width="100%" mr={1}>
        <LinearProgress variant="determinate" {...props} />
      </Box>
      <Box minWidth={35}>
        <Typography variant="body2" color="textSecondary">{`${Math.round(
          props.value
        )}%`}</Typography>
      </Box>
    </Box>
  );
}

export default function TitlebarImageList(props) {
  const classes = useStyles();
  const [loading, setLoading] = React.useState(false);
  const [progress, setProgress] = React.useState(0);
  const [filesImage, setFilesImage] = React.useState([]);
  const alert = useAlert();


  function LoadingBar() {
    const timer = setInterval(() => {
      setProgress((prevProgress) =>
        prevProgress >= 100 ? 10 : prevProgress + 10
      );
    }, 400);
    return () => {
      // setLoading(true);
      window.clearInterval(timer);
    };
  }

  const handleUploadClick = (e) => {
    e.preventDefault();
    setLoading(true);
    // console.log("filesImage: ",filesImage[0]);
    LoadingBar();

    let results = {};
    props.ItemData.map((val) => {
      return (results = val);
    });

    let promiseArray = [...filesImage].map((data) => {
      let formData = new FormData();

      if (data.size < 2000000) {
        formData.append("auction_id", results.auction_id);
        formData.append("set_id", results.set_id);
        formData.append("filename", data.name);
        formData.append("files", data);

        let config = {
          method: "post",
          maxBodyLength: Infinity,
          url: `${Api.request.URL}/lot/image/upload`,
          data: formData,
        };

        return api
          .request(config)
          .then((res) => {
            const filteredBooks = [...filesImage].filter((val) =>
              val.name.includes(data.name)
            );
            setFilesImage([
              Object.assign(...[...filteredBooks], [res.data.msg]),
            ]);
            // setLoading(false);
          })
          .catch((error) => {
            // const filteredBooks = [...filesImage].filter((val) =>
            //   val.name.includes(data.name)
            // );
            setFilesImage([
              Object.assign(props.ItemData, [error.response.data.msg]),
            ]);
            // setLoading(false);
          });
        //     setTimeout(() => {
        // }, 3000);
      }
      // const filteredBooks = [...filesImage].filter((val) =>
      //   val.name.includes(data.name)
      // );
      // setDetails(extendedSet);
      setFilesImage(() => [
        Object.assign(props.ItemData, ["Image To Large"]),
      ]);
      //setLoading(false);
    });
    setTimeout(() => {
      Promise.all(promiseArray)
        .then(() => {
          setLoading(false);
          //setFilesImage(filesImage)
          alert.success("Success")
        // window.location.reload();
        })
        .catch((error) => {
          console.log("stop", error);
        });
    }, 3000);
  };

  return (
    <div>
      <Box style={{ padding: 10, backgroundColor: "#f6f6f6" }}>
        <div className={classes.root}>
          <ImageList rowHeight={180} className={classes.imageList}>
            <ImageListItem key="Subheader" cols={2} style={{ height: "auto" }}>
              <ListSubheader component="div">Image</ListSubheader>
            </ImageListItem>
                {props.ItemData ? (
                props.ItemData.map((item) => {
                    return (
                    <ImageListItem key={item.id}>
                        <img src={item.img_url} alt={item.lot_number} />
                        {/* <ImageListItemBar
                        title={<span>Lot Number: {item.lot_number}</span>}
                        subtitle={<span>Lot Number: {item.lot_number}</span>}
                        actionIcon={
                            <IconButton aria-label={`info about ${item.id}`} className={classes.icon}>
                            <InfoIcon />
                            </IconButton>
                            }
                    /> */}
                    </ImageListItem>
                    );
                })
                ) : (
                <Typography> No Record Found </Typography>
                )}
          </ImageList>
        </div>
        <Box mt={2}>
          {loading === false ? (
            ""
          ) : (
            <LinearProgressWithLabel
              style={{ height: "10px" }}
              value={progress}
            />
          )}
        </Box>
        <Box style={{ paddingTop: 20 }}>
          <Grid container spacing={3} style={{ paddingBottom: 20 }}>
            <Grid item md={6} xs={12}>
              <TextField
                fullWidth={true}
                style={{ backgroundColor: "floralwhite" }}
                type="file"
                variant="outlined"
                // margin="normal"
                inputProps={{ accept: "image/jpeg", multiple: true }}
                color="primary"
                multiple
                onChange={(e) => setFilesImage(e.target.files)}
              />
            </Grid>
            <Grid item md={6} xs={12}>
              <Button
                margin="normal"
                fullWidth={true}
                variant="contained"
                style={{ height: "55px" }}
                color="primary"
                disabled={filesImage.length ? false : true}
                onClick={handleUploadClick}
              >
                Send Server
              </Button>
            </Grid>
          </Grid>
        </Box>
      </Box>
    </div>
  );
}
